<template>
  <main class="programmer-day-2026">
    <div class="activity-page" :style="{ backgroundImage: `url(${backgroundImage})` }">
      <!-- 中奖锦鲤飘字：所有记录在顶部同一行按接口顺序滚动 -->
      <div v-if="luckyBanner.visible" ref="luckyMarquee" class="lucky-marquee">
        <div ref="luckyMarqueeTrack" class="lucky-marquee__track" :style="luckyBanner.style">
          <span v-for="item in luckyBanner.items" :key="item.id" class="lucky-marquee__item">
            {{ item.text }}
          </span>
        </div>
      </div>

      <!-- 标题 -->
      <header class="hero">
        <img class="hero__title-img" src="../../assets/1024-2026/title.png" alt="Hello JD World" />
        <p class="hero__slogan">码上同行 · 智胜未来</p>
      </header>

      <!-- 活动信息 -->
      <section class="activity-info">
        <img
          class="activity-info__rule-img"
          src="../../assets/1024-2026/rule.png"
          alt="活动时间：10月19日~10月23日18:00；活动对象：京东全体在职员工；通关规则：逐级解锁 · 通关越多 · 奖池越大 · 惊喜不停！"
        />
        <p class="activity-info__lucky">
          全部通关的小伙伴里每日会抽<span class="activity-info__lucky-num">10</span>位<span class="activity-info__lucky-tag">AI锦鲤</span>，定制好礼从天而降～
        </p>
        <a
          class="activity-info__reward"
          href="http://sd.jd.com/article/116232?shareId=39712&isHideShareButton=1"
          target="_blank"
          rel="noopener noreferrer"
          @click="openRewardStrategy"
        >
          <img
            class="activity-info__reward-img"
            src="../../assets/1024-2026/click.png"
            alt="点击查看抽奖攻略"
          />
        </a>
      </section>

      <!-- 三个活动卡片（默认未参与） -->
      <section class="mission-list">
        <a
          v-for="item in missions"
          :key="item.id"
          class="mission-card"
          :class="['mission-card--' + item.id, { 'is-active': item.participated }]"
          :target="missionLinkTarget"
          rel="noopener noreferrer"
          @click="handleMission(item, $event)"
        >
          <img class="mission-card__bg" :src="item.bg" :alt="item.title" />
          <p v-if="item.desc || (item.prefixIcon && !item.participated)" class="mission-card__desc">
            <!-- 活动1已参与后，原 noavatar.png 图标位置由专属头像+佩戴按钮替换 -->
            <img v-if="item.prefixIcon && !item.participated" class="mission-card__desc-icon" :src="item.prefixIcon" alt="" />
            <span v-if="item.desc">{{ item.desc }}</span>
          </p>
          <!-- 已参与后展示专属头像 + 立即佩戴按钮（位置替换原 noavatar.png 图标） -->
          <div
            v-if="item.id === 1 && item.participated && item.avatarIcon"
            class="mission-card__avatar"
          >
            <img class="mission-card__avatar-img" :src="item.avatarIcon" alt="专属神灯头像" />
            <button
              class="mission-card__wear-btn"
              type="button"
              :disabled="wearing"
              @click="handleWearAvatar(item, $event)"
            >
              {{ wearing ? '佩戴中…' : '立即佩戴' }}
            </button>
          </div>
        </a>
      </section>

      <!-- 抽奖按钮:抽奖阶段显示 1-draw.png / 2-draw.png,中奖后切换为 3-draw.png 同时承载"我的奖品"入口 -->
      <a
        class="draw-button"
        href="javascript:void(0);"
        @click="handleDrawClick"
      >
        <img :src="drawImage" alt="点击抽奖" />
      </a>
      <p class="draw-notice">10月23日10:24之后自动开奖，请关注京Me「神灯技术社区」消息通知</p>

      <!-- 奖品展示 -->
      <section id="prize" class="prize">
        <img class="prize__img" src="../../assets/1024-2026/prize.png" alt="奖品展示" />
      </section>

      <!-- 底部签到图 -->
      <footer class="activity-footer">
        <img class="activity-footer__img" src="../../assets/1024-2026/sign.png" alt="主办 承办 特别支持" />
      </footer>

      <!-- 中奖弹窗 -->
      <div v-if="rewardDialog.visible" class="reward-dialog" @click.self="closeRewardDialog">
        <div class="reward-dialog__panel">
          <span class="reward-dialog__close" role="button" aria-label="关闭" @click="closeRewardDialog">
            <i class="reward-dialog__close-icon"></i>
          </span>
          <h3 v-if="rewardDialog.hasReward" class="reward-dialog__title">恭喜您获得</h3>
          <!-- 接口未返回时不展示任何图片,避免先闪现未中奖兜底图造成闪烁 -->
          <div v-if="!rewardDialog.loaded" class="reward-dialog__loading" aria-label="加载中">
            <span class="reward-dialog__loading-spinner"></span>
          </div>
          <img v-else-if="rewardDialog.rewardImg" class="reward-dialog__img" :src="rewardDialog.rewardImg" :alt="rewardDialog.rewardName" />
          <!-- 未中奖时不再展示文案，避免与 noprize.png 上的“未中奖”文字重复 -->
          <p v-if="rewardDialog.hasReward" class="reward-dialog__name">{{ rewardDialog.rewardName }}</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import api from '../../api/index.js'

export default {
  name: 'ProgrammerDay2026',
  computed: {
    // 移动端 WebView 往往禁止新开窗口，使用当前页面原生导航兜底。
    missionLinkTarget() {
      return /JDME|Android|iPhone|iPad|iPod/i.test(window.navigator.userAgent) ? '_self' : '_blank'
    }
  },
  data() {
    return {
      // 抽奖按钮图片，根据活动状态动态切换：1-draw.png / 2-draw.png / 3-draw.png
      // 3-draw.png 同时承担中奖后的"我的奖品"入口
      drawImage: require('../../assets/1024-2026/1-draw.png'),
      // 当前是否已中奖（点击抽奖按钮切到 3-draw.png 后变 true）
      // 注：不能用 drawImage.includes('3-draw.png') 判断，
      // 因为 webpack 会把 require() 解析为 hash 路径或 base64 URI，字符串中不再含 "3-draw.png"
      isLotteryWon: false,
      // 未中奖兜底图片（弹窗内使用）
      noPrizeImage: require('../../assets/1024-2026/noprize.png'),
      // SDK 在普通浏览器中也可能创建桥接对象，背景通过 UA 的 JDME 标识判断环境。
      backgroundImage: typeof window !== 'undefined' && /JDME/i.test(window.navigator.userAgent)
        ? require('../../assets/1024-2026/background.png')
        : require('../../assets/1024-2026/background2.png'),
      // 中奖奖品弹窗数据
      rewardDialog: {
        visible: false,
        rewardImg: '',
        rewardName: '',
        // 是否真实中奖（控制"恭喜您获得"标题的显示：未中奖/加载中时不展示）
        hasReward: false,
        // 我的奖品按钮 loading 状态(防止重复连续点击导致弹窗闪烁)
        loading: false,
        // 接口是否已返回(用于在加载中不展示任何图片,避免先闪现未中奖兜底图)
        loaded: false
      },
      // 中奖锦鲤飘字（完整列表共用一条滚动轨道）
      luckyBanner: {
        visible: false,
        items: [],
        style: {}
      },

      // 默认所有活动均处于「未参与」状态
      missions: [
        {
          id: 1,
          title: '乐玩·chill一下',
          desc: '参与设计一款专属神灯头像',
          prefixIcon: require('../../assets/1024-2026/noavatar.png'),
          // 已参与后展示的专属头像 + 立即佩戴按钮
          avatarIcon: require('../../assets/1024-2026/avatar.png'),
          participated: false,
          bg: require('../../assets/1024-2026/1-noparticipated.png'),
          url: 'https://canvas.jd.com/avatar-generation/embed?source=shendeng1024',
          openType: 'newTab'
        },
        {
          id: 2,
          title: '共玩·JoyAI',
          desc: '在神灯「京东1024程序员节」圈子，参与#AI生活家#话题发布畅聊',
          participated: false,
          bg: require('../../assets/1024-2026/2-noparticipated.png'),
          // 京东1024程序员节 圈子文章页
          url: 'http://shendeng.jd.com/shendeng/circle/detail/725?type=bbs&topic=AI生活家',
          openType: 'newTab'
        },
        {
          id: 3,
          title: '真玩·Max无限',
          desc: '在神灯「京东1024程序员节」圈子，发布标题以“AI是我的生产力咖啡”开头文章',
          participated: false,
          bg: require('../../assets/1024-2026/3-noparticipated.png'),
          // 京东1024程序员节 圈子畅聊页
          url: 'http://shendeng.jd.com/shendeng/circle/detail/725',
          openType: 'newTab'
        }
      ],
      // 专属头像请求中状态，防止产生并发请求
      avatarLoading: false,
      // 立即佩戴按钮的请求中状态（防止重复点击）
      wearing: false
    }
  },
  mounted() {
    this.fetchLotteryStatus()
    this.fetchLuckyGuy()
  },
  methods: {
    // 解析接口返回的 reward 字段：后端将 reward 对象以 JSON 字符串形式下发，
    // 这里做一层容错解析，避免字段缺失或格式异常时直接崩溃。
    parseReward(rawReward) {
      if (!rawReward) return null
      // 已经是对象，直接返回
      if (typeof rawReward === 'object') return rawReward
      if (typeof rawReward !== 'string') return null
      try {
        const parsed = JSON.parse(rawReward)
        return parsed && typeof parsed === 'object' ? parsed : null
      } catch (e) {
        console.error('解析 1024 reward 字段失败：', e, rawReward)
        return null
      }
    },
    // 获取抽奖活动状态：先调用 GET /api/v1/1024/customAvatar/fromCanvas，
    // 不论该接口是否有内容返回，都在其 resolve 之后再调用 GET /api/v1/1024/lottery。
    // - 进入/刷新页面时统一按此顺序预拉
    // - 接口异常时不阻塞抽奖活动状态的获取，try/catch 在 finally 链中处理
    fetchLotteryStatus() {
      // 先调 Canvas 头像接口，不论返回是否为空都继续后续流程
      const avatarPromise = api.getCustomAvatarFromCanvas()
        .then((res) => {
          // 将头像注入到任务 1（不依赖 mission.participated，
          // 以便即使抽奖状态接口异常/慢返回，头像也能尽早准备）
          const avatar = res && res.data
          if (typeof avatar === 'string' && avatar.trim()) {
            const mission = this.missions.find((item) => item.id === 1)
            if (mission) {
              mission.avatarIcon = avatar.trim()
            }
          }
        })
        .catch((err) => {
          console.error('获取 1024 专属头像失败：', err)
        })
        .finally(() => {
          // 头像接口结束后（不论成功/失败/空数据）再请求抽奖活动状态
          return this.fetchLottery()
        })
      // 兜底：若 avatarPromise 链式异常冒泡，仍保证抽奖接口被触发
      return Promise.resolve(avatarPromise).catch((err) => {
        console.error('获取 1024 抽奖活动状态前置流程失败：', err)
      })
    },
    // 真正调用 GET /api/v1/1024/lottery 并按返回值切换各活动卡片图片
    fetchLottery() {
      return api.getLottery()
        .then((res) => {
          const data = res && res.data ? res.data : res || {}
          const { activityFirst, activitySecond, activityThird, lottery } = data
          const reward = this.parseReward(data.reward)

          // 如果活动 1 已参与，使用 Canvas 头像接口返回的真实头像
          // （fetchLotteryStatus 已先行注入；此处用于保证拉取顺序一致后的状态收敛）
          if (activityFirst === 1) {
            this.fetchCustomAvatar()
          }

          // 保存中奖奖品信息（用于点击 3-draw.png 弹窗展示）
          // 仅在 rewardName 不为空时落库；为空时维持默认未中奖状态，避免污染
          if (reward && reward.rewardName) {
            this.rewardDialog.rewardImg = reward.rewardImg || ''
            this.rewardDialog.rewardName = reward.rewardName
          }

          // 根据 activityFirst 与 lottery 切换抽奖按钮图片
          // activityFirst === 0：默认 1-draw.png
          // activityFirst === 1 && lottery === false：2-draw.png
          // activityFirst === 1 && lottery === true：3-draw.png
          if (activityFirst === 1 && lottery === true) {
            this.drawImage = require('../../assets/1024-2026/3-draw.png')
            this.isLotteryWon = true
          } else if (activityFirst === 1 && lottery === false) {
            this.drawImage = require('../../assets/1024-2026/2-draw.png')
            this.isLotteryWon = false
          } else {
            this.drawImage = require('../../assets/1024-2026/1-draw.png')
            this.isLotteryWon = false
          }

          this.missions.forEach((mission) => {
            if (mission.id === 1) {
              mission.participated = activityFirst === 1
              mission.bg = require(`../../assets/1024-2026/${
                activityFirst === 1 ? '1-participated.png' : '1-noparticipated.png'
              }`)
            } else if (mission.id === 2) {
              mission.participated = activitySecond === 1
              mission.bg = require(`../../assets/1024-2026/${
                activitySecond === 1 ? '2-participated.png' : '2-noparticipated.png'
              }`)
            } else if (mission.id === 3) {
              mission.participated = activityThird === 1
              mission.bg = require(`../../assets/1024-2026/${
                activityThird === 1 ? '3-participated.png' : '3-noparticipated.png'
              }`)
            }
          })
        })
        .catch((err) => {
          // 接口异常时保持默认未参与图片，不影响用户体验
          console.error('获取 1024 抽奖活动状态失败：', err)
        })
    },
    // 获取已生成的专属头像（独立兜底调用，由 fetchLottery 内部使用）
    fetchCustomAvatar() {
      if (this.avatarLoading) return
      this.avatarLoading = true
      return api.getCustomAvatarFromCanvas()
        .then((res) => {
          const avatar = res && res.data
          if (typeof avatar !== 'string' || !avatar.trim()) return
          const mission = this.missions.find((item) => item.id === 1)
          if (mission && mission.participated) {
            mission.avatarIcon = avatar.trim()
          }
        })
        .catch((err) => {
          console.error('获取 1024 专属头像失败：', err)
        })
        .finally(() => {
          this.avatarLoading = false
        })
    },
    // 判断当前是否处于京Me（JingMe）环境
    // 京Me 环境会注入 window.jme 对象，可借此判断是否为容器内打开
    isInJme() {
      return typeof window !== 'undefined' && window.jme && window.jme.browser && typeof window.jme.browser.openUrl === 'function'
    },
    // 容器身份由 UA 判断，不依赖可能尚未就绪或发生变化的桥接对象。
    // 部分 Android / iPad 京Me UA 没有 Mobile 标记，兼容设备标记。
    isInMobileJme() {
      const ua = (typeof window !== 'undefined' && window.navigator.userAgent) || ''
      return /JDME/i.test(ua) && /Mobile|Android|iPhone|iPad|iPod/i.test(ua)
    },
      // 京Me 使用原生桥接打开新页面，保留当前活动页，返回后仍可继续点击。
    openExternalUrl(url) {
      if (!url) return
      const ua = (typeof window !== 'undefined' && window.navigator.userAgent) || ''
      // 普通浏览器也可能加载 SDK，不能仅凭桥接对象判断容器身份。
      if (/JDME/i.test(ua) && this.isInJme()) {
        try {
          window.jme.browser.openUrl({
            url,
            closeBrowser: false
          })
          return
        } catch (e) {
          console.error('[openExternalUrl] 京Me 打开失败，降级为当前页跳转：', e)
        }
      }
      // 移动端桥接缺失或抛错时，不使用可能被 WebView 拦截的新窗口。
      if (this.missionLinkTarget === '_self') {
        window.location.href = url
        return
      }
      this.openInNewTab(url)
    },
    handleMission() {
      this.$toast('活动已结束～')
      return
    },
    // 使用动态创建 <a> 标签并 click() 的方式打开外链，
    // 这种"用户手势同步触发"的方式对所有浏览器/WebView/京Me 容器都能稳定生效，
    // 比 window.open() 更可靠（window.open 在异步上下文中常被浏览器拦截）。
    openInNewTab(url) {
      if (!url) return
      // 兼容 IE：用 createElement 创建，避免 document.createElement 在某些环境被覆盖
      const a = document.createElement('a')
      a.href = url
      a.target = '_blank'
      a.rel = 'noopener noreferrer'
      // 部分浏览器要求 a 标签必须在 DOM 中才能 click
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      // 下一帧再移除，避免某些浏览器对刚被移除节点的 click 无响应
      setTimeout(() => {
        if (a.parentNode) a.parentNode.removeChild(a)
      }, 0)
    },
    // 点击"抽奖攻略"图片：新开页面跳转
    openRewardStrategy(event) {
      // 阻止模板里 <a target="_blank"> 的默认跳转（不同浏览器表现不一致），
      // 统一走 openInNewTab 逻辑，确保行为一致
      if (event) {
        event.preventDefault()
      }
      this.$toast('活动已结束～')
    },
    // 立即佩戴按钮：调用 POST /api/v1/user/customAvatar
    handleWearAvatar(item, event) {
      // 阻止冒泡，避免触发卡片的跳转行为
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      if (!item || item.id !== 1) return
      if (this.wearing) return
      this.wearing = true
      api.customAvatar({ missionId: item.id })
        .then((res) => {
          const payload = res && res.data !== undefined ? res.data : res || {}
          if (payload && payload.code !== undefined && payload.code !== 0 && payload.code !== 200) {
            this.$toast && this.$toast(payload.msg || '佩戴失败，请稍后重试')
            return
          }
          this.$toast && this.$toast(payload.msg || '佩戴成功')
        })
        .catch((err) => {
          console.error('佩戴专属神灯头像失败：', err)
          this.$toast && this.$toast('佩戴失败，请稍后重试')
        })
        .finally(() => {
          this.wearing = false
        })
    },
    // 点击抽奖按钮(同时承载中奖后的"我的奖品"入口)
// - 未中奖阶段:仅切换按钮图片,不弹窗
// - 中奖后(图片切到 3-draw.png):点击调用 GET /api/v1/1024/lottery 获取中奖信息,
//   接口返回 reward 为空时,弹窗使用 noprize.png 兜底,文案展示"未中奖"
    handleDrawClick(event) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      this.$toast('活动已结束～')
    },
    // 关闭中奖弹窗
    closeRewardDialog() {
      this.rewardDialog.visible = false
      // 重置 loaded 状态,避免下次打开时仍处于"已返回"导致闪烁逻辑失效
      this.rewardDialog.loaded = false
    },
    // 获取中奖锦鲤列表，拼成飘字文案并开启页面内飘动
    fetchLuckyGuy() {
      api.getLuckyGuy()
        .then((res) => {
          // 接口统一返回结构：{ code, msg, data: [{ name, rewardName, ... }, ...] }
          const payload = res && res.data !== undefined ? res.data : res
          const list = Array.isArray(payload) ? payload : (payload && payload.list) || []
          const items = list
            .filter((item) => item && item.name && item.rewardName)
            .map((item, index) => ({
              id: `${item.name}-${item.rewardName}-${index}`,
              text: `恭喜${item.name}获得${item.rewardName}`
            }))

          // 返回相同列表时不更新轨道，避免重复重置滚动动画。
          const unchanged = items.length === this.luckyBanner.items.length &&
            items.every((item, index) => item.id === this.luckyBanner.items[index].id)
          if (unchanged) return

          this.luckyBanner.items = items
          this.luckyBanner.visible = items.length > 0
          if (!items.length) return

          this.$nextTick(() => {
            const container = this.$refs.luckyMarquee
            const track = this.$refs.luckyMarqueeTrack
            if (!container || !track) return
            // 按整条轨道实际宽度计算时长，记录再多也保持相同速度。
            const speed = 60 // 每秒移动 60px
            const containerWidth = container.clientWidth
            this.luckyBanner.style = {
              '--marquee-container-width': `${containerWidth}px`,
              animationDuration: `${(containerWidth + track.scrollWidth) / speed}s`,
              // 首次显示时让第一条记录立即可见。
              animationDelay: `${-containerWidth / speed}s`
            }
          })
        })
        .catch((err) => {
          // 接口异常时不展示，不影响活动主流程
          console.error('获取 1024 中奖锦鲤失败：', err)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/* 仅 1024 活动页使用京东朗正字体 */
@font-face {
  font-family: JINGDONGLangZhengTi2;
  font-weight: normal;
  font-style: normal;
  src: url('../../assets/iconfont/JINGDONGLangZhengTi2-Regular.ttf') format('truetype');
}

.programmer-day-2026 {
  min-height: 100vh;
  color: #fff;
  /* 真机底部留白修复：body 的 safe-area 内边距会露出 #app 的浅灰背景，
     这里把活动页底色延伸到安全区，避免底部出现白色/浅色条 */
  margin-bottom: calc(-1 * constant(safe-area-inset-bottom));
  margin-bottom: calc(-1 * env(safe-area-inset-bottom));
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background: #020d3b;
  font-family: 'JINGDONGLangZhengTi2', 'GoogleSans', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 13px;
  line-height: 1.5;
}

.activity-page {
  position: relative;
  width: 100%;
  max-width: 1083px;
  margin: 0 auto;
  overflow: hidden;
  background: #020d3b url('../../assets/1024-2026/background.png') center top / 100% auto no-repeat;
  box-shadow: 0 0 80px rgba(30, 71, 255, .3);
}

/* 中奖锦鲤飘字（无背景、无标签,固定在活动卡片顶部最多 1 行） */
.lucky-marquee {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  /* 只显示 1 行,占用高度约 32px */
  height: 32px;
  /* 不创建新层叠上下文,确保下方 .mission-card 的点击事件不被拦截 */
  pointer-events: none;
  overflow: hidden;
}

.lucky-marquee__track {
  position: absolute;
  top: 4px;
  left: 0;
  display: flex;
  width: max-content;
  white-space: nowrap;
  animation: lucky-marquee 28s linear infinite;
  will-change: transform;
}

.lucky-marquee__item {
  flex-shrink: 0;
  padding-right: 48px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  text-shadow: 0 0 8px rgba(110, 234, 255, .7);
}

@keyframes lucky-marquee {
  0% {
    transform: translateX(var(--marquee-container-width, 1083px));
  }
  100% {
    transform: translateX(-100%);
  }
}

/* 标题 */
.hero {
  text-align: center;
  /* 上间距对齐 .activity-footer 的 margin-bottom: 30px,内容距离 background.png 顶部更远一些 */
  padding: 70px 16px 0;
}

.hero__title-img {
  display: block;
  width: 78%;
  max-width: 520px;
  margin: 0 auto;
}

.hero__subtitle {
  margin: 10px 0 4px;
  color: #6eeaff;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 4px;
  text-shadow: 0 0 12px rgba(78, 210, 255, .7);
}

.hero__slogan {
  margin: 10px 0 16px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 6px;
}

/* 活动信息（纯文字，无背景） */
.activity-info {
  width: 78%;
  margin: 0 auto;
  padding: 0 0 8px;
}

.activity-info__desc {
  margin: 0 0 10px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 2px;
}

.activity-info__rule-img {
  display: block;
  width: 80%;
  height: auto;
  margin: auto;
}

.activity-info__lucky {
  margin:10px 0 0;
  text-align: center;
  color: #ffe9b3;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 1px;
  text-shadow: 0 0 6px rgba(255, 200, 120, 0.45);
}

.activity-info__lucky-num {
  display: inline-block;
  margin: 0 2px;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  font-style: italic;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.6);
}

.activity-info__lucky-tag {
  margin: 0 2px;
  color: #ffb347;
  font-weight: 700;
  letter-spacing: 1px;
}

.activity-info__reward {
  display: block;
  margin-top: 20px;
  text-align: cnter;
  color: #6eeaff;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px;
  text-decoration: none;
}

.activity-info__reward-img {
  display: block;
  width: 28%;
  max-width: 150px;
  margin: 0 auto;
}

/* 活动卡片 */
.mission-list {
  position: relative;
  width: 78%;
  margin: 28px auto 0;
  z-index: 1; /* 确保高于飘字层,点击不被飘字遮挡 */
}

.mission-card {
  position: relative;
  display: block;
  width: 100%;
  margin-bottom: 24px;
  cursor: pointer;
  border-radius: 18px;
  overflow: hidden;
  transition: transform .25s ease;
  z-index: 1;
  /* 去除 a 标签默认样式 */
  text-decoration: none;
  color: inherit;
  -webkit-tap-highlight-color: transparent;
}

.mission-card:active { transform: scale(.98); }

.mission-card__bg {
  display: block;
  width: 100%;
  height: auto;
}

.mission-card__desc {
  position: absolute;
  /* 默认水平居中于卡片 */
  left: 0;
  right: 0;
  bottom: 22%;
  margin: 0;
  padding: 0 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
  text-shadow: 0 0 8px rgba(0, 0, 0, .55);
  letter-spacing: 1px;
  pointer-events: none;
}

/* 活动 1 已参与后,文字需为左侧的头像+佩戴按钮让出空间 */
.mission-card--1.is-active .mission-card__desc {
  left: 60px;
  right: 10px;
}

.mission-card__desc-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-right: 6px;
  vertical-align: -3px;
}

.mission-card__tag {
  position: absolute;
  top: 14px;
  right: 14px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  background: rgba(255, 120, 200, .85);
  color: #fff;
  box-shadow: 0 0 10px rgba(255, 120, 200, .55);
}

/* 已参与后展示的专属头像 + 立即佩戴按钮
   按设计稿要求:头像与按钮上下排列(纵向堆叠),
   整体置于"参与设计一款专属神灯头像"文案前方(desc 文字行左侧),
   保持在卡片图片范围内,避免超出活动1的背景图 */
.mission-card__avatar {
  position: absolute;
  /* 放在 desc 文案前方(左侧),与文案同一基线区域,
     保持在 1-participated.png 图片范围内 */
  left: 6%;
  bottom: 18%;
  /* 整体上移约 10px,让"立即佩戴"按钮与"参与设计一款专属神灯头像"文案大致对齐 */
  transform: translateY(-10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  pointer-events: auto;
}

.mission-card__avatar-img {
  display: block;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid rgba(110, 234, 255, .85);
  background: rgba(2, 13, 59, .4);
  box-shadow: 0 0 10px rgba(110, 234, 255, .55);
  object-fit: cover;
  flex-shrink: 0;
}

.mission-card__wear-btn {
  margin-top: 0;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #fff;
  background: transparent;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 16px;
  text-shadow: 0 0 4px rgba(0, 0, 0, .5);
  cursor: pointer;
  transition: background .2s ease, transform .2s ease;
}

.mission-card__wear-btn:active {
  transform: scale(.96);
}

.mission-card__wear-btn:disabled {
  opacity: .6;
  cursor: not-allowed;
}

/* 抽奖按钮 */
.draw-button {
  display: block;
  width: 200px;
  margin: 24px auto 18px;
  text-align: center;
}

.draw-button img {
  width: 100%;
  height: auto;
}

.draw-notice {
  margin: -8px auto 18px;
  color: #fff;
  font-size: 13px;
  line-height: 20px;
  text-align: center;
}

/* 奖品展示 */
.prize {
  width: 78%;
  margin: 0 auto;
  text-align: center;
}

.prize__img {
  display: block;
  width: 100%;
  height: auto;
}

/* 页脚（图片） */
.activity-footer {
  width: 78%;
  /* 底部留白交给 .programmer-day-2026 的安全区 padding 处理，避免真机底部出现空白条 */
  margin: 24px auto 0;
  text-align: center;
}

.activity-footer__img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
}

/* 中奖弹窗 */
.reward-dialog {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .65);
}

.reward-dialog__panel {
  position: relative;
  width: 78%;
  max-width: 360px;
  padding: 32px 20px 24px;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(40, 20, 90, .95), rgba(10, 30, 90, .95));
  border: 1px solid rgba(160, 89, 255, .55);
  box-shadow: 0 0 30px rgba(110, 234, 255, .35);
  text-align: center;
  color: #fff;
}

.reward-dialog__close {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  cursor: pointer;
  border-radius: 50%;
  background: rgba(255, 255, 255, .12);
  /* 关闭按钮固定不动,不做 hover 旋转动画 */
  transition: background .2s ease;
}

.reward-dialog__close:hover {
  background: rgba(255, 126, 200, .35);
}

/* 纯 CSS 绘制 × 关闭图标 */
.reward-dialog__close-icon {
  position: relative;
  width: 16px;
  height: 16px;
}

.reward-dialog__close-icon::before,
.reward-dialog__close-icon::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 16px;
  height: 2px;
  background: #fff;
  border-radius: 1px;
  transform-origin: center;
}

.reward-dialog__close-icon::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.reward-dialog__close-icon::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.reward-dialog__title {
  margin: 0 0 16px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 4px;
  color: #6eeaff;
  text-shadow: 0 0 10px rgba(110, 234, 255, .6);
}

.reward-dialog__img {
  display: block;
  width: 60%;
  max-width: 220px;
  margin: 0 auto 14px;
}

/* 弹窗加载中:接口未返回时展示旋转菊花,避免先闪现未中奖兜底图造成闪烁 */
.reward-dialog__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60%;
  max-width: 220px;
  height: 120px;
  margin: 0 auto 14px;
}

.reward-dialog__loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid rgba(110, 234, 255, .25);
  border-top-color: #6eeaff;
  border-radius: 50%;
  animation: reward-dialog-spin .8s linear infinite;
  box-shadow: 0 0 12px rgba(110, 234, 255, .45);
}

@keyframes reward-dialog-spin {
  to { transform: rotate(360deg); }
}

.reward-dialog__name {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #ffd86b;
  text-shadow: 0 0 8px rgba(255, 216, 107, .5);
}

/* 移动端 */
@media (max-width: 600px) {
  .programmer-day-2026 { font-size: 12px; }
  .lucky-marquee__item { font-size: 12px; }
  .hero { padding-top: 40px; }
  .hero__title-img { width: 86%; }
  .hero__subtitle { font-size: 14px; letter-spacing: 2px; }
  .hero__slogan { font-size: 15px; letter-spacing: 3px; }
  .activity-info, .mission-list, .prize, .activity-footer { width: 90%; }
  .activity-info__desc { font-size: 14px; }
  .activity-info__lucky { font-size: 13px; }
  .activity-info__lucky-num { font-size: 17px; }
  .activity-info__reward { font-size: 12px; }
  .activity-info__reward-img { width: 32%; max-width: 120px; }
  .mission-card__desc { font-size: 13px; line-height: 18px; bottom: 24%; left: 0; right: 0; }
  /* 移动端:活动1已参与时,文字为左侧头像+按钮让出空间 */
  .mission-card--1.is-active .mission-card__desc { left: 50px; right: 8px; }
  .mission-card__avatar { left: 4%; bottom: 20%; gap: 4px; transform: translateY(-10px); }
  .mission-card__avatar-img { width: 40px; height: 40px; }
  .mission-card__wear-btn { font-size: 10px; padding: 2px 6px; }
  .draw-button { width: 170px; }
  /* .prize__title 已删除（prize.png 内置标题文字），不再保留移动端规则 */
}
</style>